import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/user/user3.jpg'
import _imports_1 from '../../../assets/images/user/user1.jpg'
import _imports_2 from '../../../assets/images/user/user5.jpg'
import _imports_3 from '../../../assets/images/user/user6.jpg'
import _imports_4 from '../../../assets/images/user/user7.jpg'


const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-15 mb-md-25 d-sm-flex align-items-center justify-content-between\"><h6 class=\"card-title fw-bold mb-0\">Unsolved Tickets</h6><div class=\"d-flex align-items-center mt-12 mt-md-0\"><form class=\"me-15\"><div class=\"input-group\"><input type=\"text\" class=\"form-control shadow-none fw-medium ps-12 pt-8 pb-8 pe-12 letter-spacing\" placeholder=\"Search\"><button class=\"default-btn position-relative transition border-0 text-white ps-12 pe-12 rounded-1\" type=\"button\"><i class=\"flaticon-search-interface-symbol position-relative\"></i></button></div></form><div class=\"dropdown\"><button class=\"dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"flaticon-dots\"></i></button><ul class=\"dropdown-menu\"><li><a class=\"dropdown-item d-flex align-items-center\" href=\"javascript:void(0);\"><i class=\"flaticon-view lh-1 me-8\"></i> View</a></li><li><a class=\"dropdown-item d-flex align-items-center\" href=\"javascript:void(0);\"><i class=\"flaticon-pen lh-1 me-8\"></i> Edit</a></li><li><a class=\"dropdown-item d-flex align-items-center\" href=\"javascript:void(0);\"><i class=\"flaticon-delete lh-1 me-8\"></i> Delete</a></li></ul></div></div></div>", 1)
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " CLIENT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " SUBJECT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " STATUS "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " PRIORITY "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " AGENT ")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "form-check mb-0" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "form-check-input shadow-none",
        type: "checkbox"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        class: "rounded-circle me-8",
        width: "24",
        height: "24",
        alt: "user"
      }),
      /*#__PURE__*/_createTextVNode(" J. Ronan ")
    ])
  ])
], -1)
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-success" }, "Recent")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-danger text-uppercase" }, " URGENT ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
  /*#__PURE__*/_createElementVNode("select", { class: "form-select shadow-none rounded-0 fs-md-15 fs-lg-16 fw-medium" }, [
    /*#__PURE__*/_createElementVNode("option", { selected: "" }, "J. Linowiski"),
    /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Z. White"),
    /*#__PURE__*/_createElementVNode("option", { value: "2" }, "C. Benden"),
    /*#__PURE__*/_createElementVNode("option", { value: "3" }, "A. Smith")
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "form-check mb-0" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "form-check-input shadow-none",
        type: "checkbox"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        class: "rounded-circle me-8",
        width: "24",
        height: "24",
        alt: "user"
      }),
      /*#__PURE__*/_createTextVNode(" V. James ")
    ])
  ])
], -1)
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-danger" }, "Overdue")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-primary text-uppercase" }, " HIGH ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
  /*#__PURE__*/_createElementVNode("select", { class: "form-select shadow-none rounded-0 fs-md-15 fs-lg-16 fw-medium" }, [
    /*#__PURE__*/_createElementVNode("option", null, "J. Linowiski"),
    /*#__PURE__*/_createElementVNode("option", {
      value: "1",
      selected: ""
    }, "Z. White"),
    /*#__PURE__*/_createElementVNode("option", { value: "2" }, "C. Benden"),
    /*#__PURE__*/_createElementVNode("option", { value: "3" }, "A. Smith")
  ])
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "form-check mb-0" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "form-check-input shadow-none",
        type: "checkbox"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_2,
        class: "rounded-circle me-8",
        width: "24",
        height: "24",
        alt: "user"
      }),
      /*#__PURE__*/_createTextVNode(" A. Carter ")
    ])
  ])
], -1)
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-info" }, "Remaining")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-info-light text-uppercase" }, " MEDIUM ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
  /*#__PURE__*/_createElementVNode("select", { class: "form-select shadow-none rounded-0 fs-md-15 fs-lg-16 fw-medium" }, [
    /*#__PURE__*/_createElementVNode("option", null, "J. Linowiski"),
    /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Z. White"),
    /*#__PURE__*/_createElementVNode("option", {
      value: "2",
      selected: ""
    }, "C. Benden"),
    /*#__PURE__*/_createElementVNode("option", { value: "3" }, "A. Smith")
  ])
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "form-check mb-0" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "form-check-input shadow-none",
        type: "checkbox"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_3,
        class: "rounded-circle me-8",
        width: "24",
        height: "24",
        alt: "user"
      }),
      /*#__PURE__*/_createTextVNode(" B. White ")
    ])
  ])
], -1)
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-primary" }, "Responded")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-warning text-uppercase" }, " LOW ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
  /*#__PURE__*/_createElementVNode("select", { class: "form-select shadow-none rounded-0 fs-md-15 fs-lg-16 fw-medium" }, [
    /*#__PURE__*/_createElementVNode("option", null, "J. Linowiski"),
    /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Z. White"),
    /*#__PURE__*/_createElementVNode("option", { value: "2" }, "C. Benden"),
    /*#__PURE__*/_createElementVNode("option", {
      value: "3",
      selected: ""
    }, "A. Smith")
  ])
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "form-check mb-0" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "form-check-input shadow-none",
        type: "checkbox"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_4,
        class: "rounded-circle me-8",
        width: "24",
        height: "24",
        alt: "user"
      }),
      /*#__PURE__*/_createTextVNode(" S. Smith ")
    ])
  ])
], -1)
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-muted" }, "Closed")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-danger text-uppercase" }, " URGENT ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
  /*#__PURE__*/_createElementVNode("select", { class: "form-select shadow-none rounded-0 fs-md-15 fs-lg-16 fw-medium" }, [
    /*#__PURE__*/_createElementVNode("option", { selected: "" }, "J. Linowiski"),
    /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Z. White"),
    /*#__PURE__*/_createElementVNode("option", { value: "2" }, "C. Benden"),
    /*#__PURE__*/_createElementVNode("option", { value: "3" }, "A. Smith")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_7,
              _createElementVNode("td", _hoisted_8, [
                _createVNode(_component_router_link, {
                  to: "/ticket-preview",
                  class: "text-decoration-none"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Adlash Dashboard Design ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_9,
              _hoisted_10,
              _hoisted_11
            ]),
            _createElementVNode("tr", null, [
              _hoisted_12,
              _createElementVNode("td", _hoisted_13, [
                _createVNode(_component_router_link, {
                  to: "/ticket-preview",
                  class: "text-decoration-none"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Higher Calculus App Design ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_14,
              _hoisted_15,
              _hoisted_16
            ]),
            _createElementVNode("tr", null, [
              _hoisted_17,
              _createElementVNode("td", _hoisted_18, [
                _createVNode(_component_router_link, {
                  to: "/ticket-preview",
                  class: "text-decoration-none"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Admin Issue ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_19,
              _hoisted_20,
              _hoisted_21
            ]),
            _createElementVNode("tr", null, [
              _hoisted_22,
              _createElementVNode("td", _hoisted_23, [
                _createVNode(_component_router_link, {
                  to: "/ticket-preview",
                  class: "text-decoration-none"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Email Submission Issue ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_24,
              _hoisted_25,
              _hoisted_26
            ]),
            _createElementVNode("tr", null, [
              _hoisted_27,
              _createElementVNode("td", _hoisted_28, [
                _createVNode(_component_router_link, {
                  to: "/ticket-preview",
                  class: "text-decoration-none"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Adlash Design Issue ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_29,
              _hoisted_30,
              _hoisted_31
            ])
          ])
        ])
      ])
    ])
  ]))
}